import styled, { css } from "react-emotion/macro"
import { color, mq, font } from "../../styles/variables"

const common = css`
  background-color: ${color.rgb.white[0]};

  a:not(.btn) {
    color: ${color.rgb.black[0]};
  }
`

export const Wrapper = styled("header")`
  ${common};
  display: flex;
  padding: 15px 0;
  font-size: 14px;

  .header-menu-desktop {
    display: flex;
  }

  &,
  a:not(.btn) {
    color: ${color.rgb.black[0]};
    font-weight: 400;
    text-transform: uppercase;
  }

  .logo-wrapper {
    img {
      width: 100px;
      padding-right: 30px;
    }
  }

  .bars {
    display: flex;
    flex-direction: column;
    flex-grow: 2;
    justify-content: space-between;
  }

  .top,
  .bottom {
    display: flex;
    margin-left: 15px;
    justify-content: space-between;
  }

  .top {
    justify-content: flex-end;
    align-items: center;

    > * {
      margin-left: 22.5px;
    }
  }

  .bottom {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .btn-wrapper {
      margin-left: 15px;
    }
  }
`

const commonMobile = css`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .logo-wrapper {
    img {
      padding-right: 30px;
      max-width: 60px;
    }
  }

  .hamburger {
    transform: scale(0.75);
  }

  .btn {
    display: none;
    margin-right: 15px;
  }

  .right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  ${mq.sm(css`
    .btn {
      display: inline;
    }
  `)} ${common};
`

export const WrapperMobile = styled("header")`
  padding: 5px 0;

  ${commonMobile};
`

export const overlayClassName = css`
  ${common};

  .above {
    ${commonMobile};
  }

  nav {
    text-align: center;
    font-weight: 400;
    text-transform: uppercase;
    font-size: 28px;
    margin-bottom: 60px;
    margin-top: 60px;

    a {
      display: block;
      padding: 20px;

      &:hover, &:focus {
        text-decoration: none;
        color ${color.rgb.orange[0]};
      }
    }
  }

  .below {
    padding-bottom: 60px;
    text-align: center;
  }

  .item-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    position: relative;

    > button {
      position: absolute;
      top: 15px;
      right: 0;
      border: none;
      background: none;
      padding: 10px;
      cursor: pointer;
    }
  }

  .subitems-container {
    width: 100%;
    background-color: ${color.rgb.gray[2]};
    margin-left: -15px;
    margin-right: -15px;
    padding: 15px;
  }


  .subitem-wrapper > a {
    font-size: 20px;
  }

  .subsubitem-wrapper {
    background-color: ${color.rgb.gray[3]};
    margin-left: -15px;
    margin-right: -15px;
    padding: 0 15px;

    a {
      font-size: 16px;
    }
  }

  .btns-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;

    > * { margin: 0 10px; }
  }

  .mycsl {
    margin-bottom: 30px; 

    > span {
      display: flex;
      flex-wrap: wrap;
    }

    a {
      margin: 0 15px; 
      text-transform: uppercase;
    }
  }

  .services {
    text-transform: uppercase;
    font-size: ${font.size.main[0]};
  }
`



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Header/style.js